module.exports = __webpack_public_path__ + "static/media/A37.0444dc12.png";